module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "Prelims-head",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("This book is dedicated to the memory of Peggy, my beautiful, loving, amazing Mum, who passed away in February 2020. Her kindness, strength, warmth, humour and selfless Spartan courage never ceased to astound and inspire me. "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Until we meet again little Mama...")])]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("I would also like to dedicate this work to the memory of Mum’s loving husband Jim and my dear late father, who passed away on Good Friday, 2018.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Death takes the body. God takes the soul."), _c('br'), _vm._v("My mind holds the memories, my heart keeps the love."), _c('br'), _vm._v("My faith lets me know, I ")]), _c('span', {
    staticClass: "bold-italic _idGenCharOverride-1"
  }, [_vm._v("will")]), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v(" see them again.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43438724","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781788480116_EPUB3.vue
// module id = 66
// module chunks = 0